import React, {useState} from 'react';
import {toast} from 'react-toastify';
import {connect} from "react-redux";
import {Form, Button, Modal} from "react-bootstrap";
import CircularProgress from '@material-ui/core/CircularProgress';
import {injectIntl} from "react-intl";
import {withStyles} from "@material-ui/core/styles";
import styles from "./styles";
import {addLanguage} from '../../../crud/language.crud';
import * as language from "../../../store/ducks/language.duck";
const CreateLanguage = (props) => {
    const {classes} = props;
    const [errors,
        setErrors] = useState({title: null, icon: null});
    const [loading,
        setLoading] = useState(false);
    const [title,
        setTitle] = useState('');
    const [code,
        setCode] = useState('');
   

    const onTitleChangeHandler = (event) => {
        setTitle(event.target.value);
        if (!event.target.value) {
            setErrors({
                ...errors,
                title: 'Title is required'
            });
        } else {
            setErrors({
                ...errors,
                title: null
            });
        }
    }

    const onCodeChangeHandler = (event) => {
        setCode(event.target.value);
        if (!event.target.value) {
            setErrors({
                ...errors,
                code: 'Code is required'
            });
        } else {
            setErrors({
                ...errors,
                code: null
            });
        }
    }

    const resetState = () => {
        setTitle('');
        setCode('');
       
        setErrors({
            title: null, 
            code: null
        });
    }

    const validForm = () => {
        let e = true;

        if (!title && !code) {
         
            setErrors({
                ...errors,
                title: 'Title is required',
                code: 'Code is required'
            });
            e = false;
        } else if (!title) {
            setErrors({
                ...errors,
                title: 'Title is required'
            });
            e = false;
        } else if (!code) {
            setErrors({
                ...errors,
                code: 'Code is required'
            });
            e = false;
        } else {
            setErrors({
                ...errors,
                title: null,
                code: null
            });
        }
        return e;
    }

    const handleSubmit = () => {
        if (validForm()) {
            setLoading(true);
            addLanguage({name: title, code}).then((output) => {
                if (output.data.success) {
                    props.languageAdded({skip: 0, limit: 5});
                    resetState();
                    setLoading(false);
                    toast.success('Language is successfully added!', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined
                    });
                    props.handleClose('languages');
                }
            }).catch((error) => {
                console.log('error', error);
                setLoading(false);
            });
        }
    };

    // const validateSize = (event) => {
    //     let file = event.target.files[0];
    //     let size = 1000000;
    //     let err = '';
    //     console.log(file.size);
    //     if (file.size > size) {
    //         err = file.type + 'is too large, please pick a smaller file\n';
    //         toast.error(err);
    //     }
    //     return true
    // };
   

    return (
        <React.Fragment>
            <Modal
                show={props.show}
                onHide={() => {
                resetState();
                props.handleClose('languages')
            }}>
                <Modal.Header closeButton>
                    <Modal.Title>Language</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="languageForm.title">
                            <Form.Label>Name</Form.Label>
                            <Form.Control
                                type="text"
                                value={title}
                                onChange={onTitleChangeHandler}
                                isInvalid={!!errors.title}/>
                            <Form.Control.Feedback type="invalid">
                                {errors.title}
                            </Form.Control.Feedback>

                        </Form.Group>
                        <Form.Group controlId="languageForm.code">
                            <Form.Label>Code</Form.Label>
                            <Form.Control
                                type="text"
                                value={code}
                                onChange={onCodeChangeHandler}
                                isInvalid={!!errors.code}/>
                            <Form.Control.Feedback type="invalid">
                                {errors.code}
                            </Form.Control.Feedback>

                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={() => {
                        resetState();
                        props.handleClose('languages');
                    }}>
                        Close
                    </Button>
                    <Button
                        variant="primary"
                        style={{
                        position: "relative"
                    }}
                        onClick={() => handleSubmit()}
                        disabled={loading}>
                        {loading && <CircularProgress size={24} className={classes.buttonProgress}/>}Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    )
};

const mapStateToProps = state => {
    return {data: state};
};

const mapDispatchToProps = dispatch => {
    return {
        languageAdded: ({skip, limit}) => dispatch(language.actions.languageAdded({skip, limit}))
    };
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles((theme) => ({
    ...styles(theme)
}), {withTheme: true})(CreateLanguage)));
